import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

const Donate = ({ onClose, isVisible }) => {

    // State hooks for form fields
    const [email, setEmail] = useState('');
    const [amount, setAmount] = useState('');

    
  if (!isVisible) {
    return null;
  }

    // Handle form submission
    const handleSubmit = (e) => {
      e.preventDefault(); // Prevent default form submission behavior
      // Here you can handle the submission, like sending data to a server
    };

    
  return (
<Modal show={isVisible} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Donate</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicAmount">
            <Form.Label>Amount (USD $)</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Donate
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
    /*
    <div style={{
      position: 'fixed', 
      top: 0, 
      left: 0, 
      right: 0, 
      bottom: 0, 
      backgroundColor: 'rgba(0, 0, 0, 0.5)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      zIndex: 1000, // Ensure it's above other content
    }}>
      <div style={{
        backgroundColor: '#fff',
        padding: '20px', 
        borderRadius: '5px',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Content of the overlay }
        <div className="account-page">
          <h2>Account Settings</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="amount">Amount (USD $):</label>
              <input
                type="text"
                id="amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                required
              />
            </div>
            <button type="submit">Donate</button>
            <button onClick={onClose}>Close</button>

          </form>
        </div>
      </div>
    </div>
    */
  );
};

export default Donate;
